import { useEffect, useState } from 'react';

import { useNavigationType } from 'react-router-dom';

export type TNavigationSource =
	| 'initial-load'
	| 'internal'
	| 'back-forward'
	| 'typed-or-bookmarked'
	| 'reload';

export function useNavigationSource(): TNavigationSource {
	const navigationType = useNavigationType();
	const [source, setSource] = useState<TNavigationSource>('initial-load');

	useEffect(() => {
		const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;

		if (!navEntry) return;

		if (navEntry.type === 'reload') {
			setSource('reload');
		} else if (navEntry.type === 'back_forward') {
			setSource('back-forward');
		} else if (navEntry.type === 'navigate') {
			if (navigationType === 'POP') {
				setSource('typed-or-bookmarked');
			} else {
				setSource('internal');
			}
		}
	}, [navigationType]);

	return source;
}
